<div >
  @if (offerTypeName && !isTrip) {
    <span class="offer-type-name {{ offerType }} margin-right-xs">{{
      offerTypeName
    }}</span>
  }
  @if (isTrip) {
    <span class="offer-type-name {{ offerTypeName }} margin-right-xs">{{ offerTypeName | titlecase}}</span>
  }
  @if (offer) {
    <span class="offer-label">{{ offer }}</span>
  }
  @if (!offer) {
    <span class="offer-label">N/A</span>
  }
</div>
@if (secondaryOffer) {
  <span  class="secondary-offer-label secondary-driver-quote"
    >${{ secondaryOffer }}</span
    >
  }
